import { Component, ViewChild, ElementRef } from '@angular/core';
import { NavController, ModalController } from 'ionic-angular';
import { LoadingController, Refresher } from 'ionic-angular';
import { Events} from 'ionic-angular';
import { ItineraireProvider } from '../../providers/itineraire/itineraire';
import leaflet from 'leaflet';

// @IonicPage()
@Component({
  selector: 'page-home',
  templateUrl: 'home.html'
})
export class HomePage {

  START_STATION_PLACEHOLDER: string = 'Séléctionnez la station de départ';
  END_STATION_PLACEHOLDER: string = 'Séléctionnez la station d\'arrivée';
  startStationName: string = '';//this.START_STATION_PLACEHOLDER;
  endStationName: string = '';//this.END_STATION_PLACEHOLDER;
  path = [];
  currentPath = [];
  public operatorIcon = {
      B: "./assets/imgs/icon_bus.png",
      E: "./assets/imgs/icon_bus.png",
      M: "./assets/imgs/icon_metro.png",
      T: "./assets/imgs/icon_tram.png"
  };

  @ViewChild('map') mapContainer: ElementRef;
  @ViewChild(Refresher) refresher: Refresher;
  map: any;
  public installPromptEvent;

  constructor(public navCtrl: NavController,
              public modalCtrl : ModalController,
              public itineraireService: ItineraireProvider,
              public loadingCtrl: LoadingController,
              public events: Events) {

  events.subscribe('itineraire:received', () => {
      // user and time are the same arguments passed in `events.publish(user, time)`
      // console.log('Path received !');
      document.getElementById('welcome-message').style.display = 'none';
      this.drawPath();
      this.refresher.complete();
    });
  }

  ionViewDidLoad() {
    // this.startStationName = "Meteo, Dar El Beïda";
    // this.endStationName = "Bouchaoui - CNR, Cheraga";
    // this.getPath();
  }
  ionViewWillEnter() {
    window.addEventListener('beforeinstallprompt', (event) => {
      console.log("App Install Prompt !");
      // Prevent Chrome <= 67 from automatically showing the prompt
      event.preventDefault();
      // Stash the event so it can be triggered later.
      this.installPromptEvent = event;
      // Update the install UI to notify the user app can be installed
      // document.querySelector('#install-button').disabled = false;
      this.appInstallPrompt();
    });
  }
  public appInstallPrompt() {
    // Update the install UI to remove the install button
    // document.querySelector('#install-button').disabled = true;
    // Show the modal add to home screen dialog
    this.installPromptEvent.prompt();
    // Wait for the user to respond to the prompt
    this.installPromptEvent.userChoice.then((choice) => {
      if (choice.outcome === 'accepted') {
        console.log('App Installed !');
      } else {
        console.log('App not Installed !');
      }
      // Clear the saved prompt since it can't be used again
      this.installPromptEvent = null;
    });
  }
  doRefresh(refresher) {
    if (this.startStationName && this.endStationName) {
      // console.log('Begin async operation', refresher);
      this.getPath();

    // setTimeout(() => {
    //   console.log('Async operation has ended');
    //   refresher.complete();
    // }, 1000);
    } else {
      refresher.complete();
    }
  }

  /* ######################################################################
     Ouvrir Modal de selection de station de départ
  ###################################################################### */
  public openStartSelect() {
    var data = {
      message : 'Station de départ',
      ssName : this.startStationName
    };
    var stationselectPage = this.modalCtrl.create('StationSelectPage',data);
    stationselectPage.onDidDismiss(data => {
      if ((data) && (data.stationName)) {
        this.startStationName = data.stationName;
        this.getPath();
      }
    });
    stationselectPage.present();
  }

  /* ######################################################################
     Ouvrir Modal de selection de station de départ
  ###################################################################### */
  public openEndSelect() {
    var data = {
      message : 'Station d\'arrivée',
      esName : this.endStationName
    };
    var stationselectPage = this.modalCtrl.create('StationSelectPage',data);
    stationselectPage.onDidDismiss(data => {
      if ((data) && (data.stationName)) {
        this.endStationName = data.stationName;
        this.getPath();
      }
    });
    stationselectPage.present();
  }

  /* ######################################################################
     Recuperation de l'itineraire
  ###################################################################### */
  public getPath () {
    if ( !(this.startStationName=='') && !(this.endStationName=='')
          && !(this.startStationName==this.endStationName) ) {

      // Recuperation de l'itineraire
      this.itineraireService.getPath(this.startStationName, this.endStationName);
      // this.drawPath();
    }
  }
  public swap_from_to () {
    var tmp=this.startStationName;
    this.startStationName=this.endStationName;
    this.endStationName=tmp;
    this.getPath();
    // console.log("swap !");
//    ga('send', 'event', 'Search Tools', 'Swap Fields', selectfrom + ' > ' + document.getElementById('select-from').value);
  }

  public toggleFold(seg_index:number) {
    // console.log("toggleFold " + seg_index + "!");
    this.itineraireService.currentPath[seg_index].folded=!this.itineraireService.currentPath[seg_index].folded;
  }

  /* ######################################################################

  ###################################################################### */
  public searchFilterNoWalk() {
    // return this.currentPath.filter(x => x.data.type == type);
  }

  /* ######################################################################
     Affichage du trajet sur la carte
  ###################################################################### */
  public drawPath () {
    // console.log("Drawing map...");
    this.loadmap();

    if (this.itineraireService.currentPath.length>0) {
      let markerGroup = leaflet.featureGroup();
      let polylineGroup = leaflet.featureGroup();
      // Parcours des segments
      this.itineraireService.currentPath.forEach(function(segment,index,arr) {
        var latlngs = [];
        // Parcours des stations du segment
        segment.stations.forEach(function(station) {
          latlngs.push([station.stop_lat, station.stop_lon]);
          // this.addMarker(station.sname, station.stop_lat, station.stop_lon,markerGroup);
        }, this)
        this.addMarker(segment.stations[0].sname, segment.stations[0].stop_lat, segment.stations[0].stop_lon,markerGroup);
        this.addMarker(segment.stations[segment.stations.length-1].sname,
          segment.stations[segment.stations.length-1].stop_lat,
          segment.stations[segment.stations.length-1].stop_lon,
          markerGroup);
        // Ajout de la ligne du segment
        var polyline_black = leaflet.polyline(latlngs, {color: 'black', weight:7});
        var polyline = leaflet.polyline(latlngs, {color: (segment.op_color ? segment.op_color : 'black'), weight:3});
        polylineGroup.addLayer(polyline_black);
        polylineGroup.addLayer(polyline);
      }, this)
      // Ajout des Layers a la Map
      this.map.addLayer(polylineGroup);
      this.map.addLayer(markerGroup);
      // Ajustement de la Map aux Layers
      this.map.fitBounds(polylineGroup.getBounds(), {padding:[20,20]});
    }
  }

  /* ######################################################################
     Chargement de la carte
  ###################################################################### */
  public addMarker (name:string, lat:string, lon:string, markerGroup:any) {
    let circle:any = leaflet.circleMarker([lat, lon], {
      color: 'black',
      weight: 2,
      fillColor: 'white',
      fillOpacity: 1,
      radius: 4
    }).bindPopup(name);
    markerGroup.addLayer(circle);
  }

  private loadmap() {
    // console.log("Loading map...");
    if(this.map) this.map.remove();
    this.map = leaflet.map("map", {
      scrollWheelZoom: false,
      zoomControl: false,
      doubleClickZoom: false,
      touchZoom: 'center',
      dragging: false,
      minZoom: 8
    });
    // this.map.eachLayer(function (layer) {
    //   console.log(layer);
    //   layer.remove();
    // });
    this.map.attributionControl.setPrefix(false);
    let mapboxTokken = "pk.eyJ1IjoiZHphaXJ0cmFuc3BvcnQiLCJhIjoiY2pocTgwdmkyMHRjODM2cnVuMWM1cmhvYiJ9.y47fdHYjDqNxn19_qHTBJA";
    leaflet.tileLayer('https://api.tiles.mapbox.com/v4/{id}/{z}/{x}/{y}.png?access_token=' + mapboxTokken, {
      // attribution: 'www.dzairtransport.com',
      maxZoom: 18,
      id: 'mapbox.outdoors',
      accessToken: mapboxTokken
    }).addTo(this.map);

    // Localisation et ajout d'un Marker
    // this.map.locate({
    //   setView: true,
    //   maxZoom: 10
    // }).on('locationfound', (e) => {
    //   let markerGroup = leaflet.featureGroup();
    //   let marker: any = leaflet.marker([e.latitude, e.longitude]).on('click', () => {
    //     alert('Marker clicked');
    //   })
    //   markerGroup.addLayer(marker);
    //   this.map.addLayer(markerGroup);
    // }).on('locationerror', (err) => {
    //     alert(err.message);
    // })
  }
}



// WEBPACK FOOTER //
// ./src/pages/home/home.ts